module.exports = __webpack_public_path__ + "927a04d520f94b0eb135ab2db5cdd7fe.fbx";